import { createContext, useContext } from 'react'
import { useProducao360 } from '../hooks/useProducao360'

const Producao360Context = createContext()

export const Producao360Provider = ({ children }) => {
  const producao360 = useProducao360()

  return (
    <Producao360Context.Provider
      value={{
        ...producao360,
      }}
    >
      {children}
    </Producao360Context.Provider>
  )
}

export const useProducao360Context = () => {
  const context = useContext(Producao360Context)

  if (!context) {
    throw new Error('useProducao360Context must be used within a Producao360Provider')
  }

  return context
}
